import moment, {type Moment} from 'moment';
import React, {useMemo} from 'react';

import MomentDatePicker from '../../../components/DatePicker/MomentDatePicker';

import {
  parseStudyDateValue,
  PCF_STUDY_DATE_FORMAT
} from './goalScopeValidation';

interface StudyDateInputProps {
  value?: string;
  onChange?: (value: string | undefined) => void;
  className?: string;
}

const StudyDateInput: React.FC<StudyDateInputProps> = ({
  value,
  onChange,
  className
}) => {
  const momentValue = useMemo(
    () => (value ? parseStudyDateValue(value) : undefined),
    [value]
  );

  const handleChange = (date: Moment | null): void => {
    onChange?.(
      date?.isValid() ? date.format(PCF_STUDY_DATE_FORMAT) : undefined
    );
  };

  return (
    <MomentDatePicker
      value={momentValue}
      onChange={handleChange}
      format={PCF_STUDY_DATE_FORMAT}
      inputReadOnly
      showNow={false}
      disabledDate={(current) =>
        current != null && current.isAfter(moment(), 'day')
      }
      style={{width: '100%'}}
      className={className}
    />
  );
};

export default StudyDateInput;
